<div class='main'>
    <div class='dropdownMainStyle' [ngClass]="{ 'dropdownMainNotSelected' : !isOpen, 'dropdownSelected': isOpen  }" (click)='openClose()'>
        <span class='label'>{{ getLabel()  }}</span> <span class='caret'> {{ !isOpen ? '&#9660;' : '&#9650;' }}</span>
    </div>
    <div class='content' *ngIf='isOpen'>
        <div class='item' (click)='clickEvent(i)' *ngFor='let item of dataSource; let i=index'>
            <span *ngIf='isIndexSelected(i)'>&#10003;</span> &nbsp;{{ getItemText(item) }}
        </div>
    </div>
</div>